export const L_REQUEST_AP_ENABLE_PREVIEW = 'L_REQUEST_AP_ENABLE_PREVIEW';
export const L_REQUEST_AP_DISABLE_PREVIEW = 'L_REQUEST_AP_DISABLE_PREVIEW';
export const L_REQUEST_AP_APP_ENABLED_PREVIEW = 'L_REQUEST_AP_APP_ENABLED_PREVIEW';
